"use strict";
/**
 * An axios interceptor to that detects and attempts to resolve errors. If a
 * request is rejected with a matching error then this interceptor will call the
 * provided error resolution logic. The interceptor will pause any new network
 * requests that are made while the resolution logic is running. After the
 * resolution logic runs the interceptor will retry all requests that failed
 * with matching errors and resume all paused requests. The onSuccess argument
 * can be used to modify a request's config before it is retried or resumed. If
 * resolution fails the original error is thrown.
 *
 * IMPORTANT: Set the `skipErrorResolution` Axios config field to true on any
 * axios requests that are part of the actual error resolution logic. Otherwise
 * this interceptor will run the error resolution logic for failed resolutions,
 * creating a black hole and destroying us all.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_pause_interceptor_1 = __importDefault(require("./axios-pause-interceptor"));
const addErrorResolutionInterceptor = ({ axios, interceptError, resolveError, onSuccess = (config) => config, onFailure = (error) => {
    throw error;
}, }) => {
    let cache = null;
    return axios.interceptors.response.use((response) => response, async (originalError) => {
        const shouldIntercept = await interceptError(originalError);
        if (!shouldIntercept || originalError.config.skipErrorResolution) {
            throw originalError;
        }
        if (!cache) {
            const errorResolution = resolveError(originalError);
            const pauseInterceptor = (0, axios_pause_interceptor_1.default)({
                axios,
                pauseUntil: errorResolution,
                onSuccess,
            });
            cache = { errorResolution, pauseInterceptor };
        }
        try {
            await cache.errorResolution;
            cache = null;
            const config = await onSuccess(originalError.config);
            config.skipErrorResolution = true;
            return axios(config);
        }
        catch (resolutionError) {
            cache = null;
            onFailure(originalError, resolutionError);
        }
    });
};
exports.default = addErrorResolutionInterceptor;
